module.exports = __webpack_public_path__ + "static/media/database.79e44513.svg";